export const APP_NAME = 'Share.Tips'
